import { useHistory } from "react-router-dom/cjs/react-router-dom.min"

function Logout() {
  var history = useHistory()
  var name = localStorage.getItem('mapyourmove_name')
  const handleSubmit = (event) => {
    localStorage.removeItem('mapyourmove_name')
    localStorage.removeItem('mapyourmove_token')
    history.replace('/')
  }

  return(
    <>
    <span>{name}</span>
      <button onClick={handleSubmit}>
        Logout
      </button>
    </>
  )
}

export default Logout